import React from 'react';
import Modal from '../../../components/Modal';
import { useMosruStore } from '../store/use-mosru-store';
import LoadingSpinner from '../../../components/LoadingSpinner';
import InfoIcon from '@mui/icons-material/Info';
import IntegrationButton from './IntegrationButton';

const typeCounter = { 1: 'Счетчик холодной воды', 2: 'Счетчик горячей воды' };

const keys = [
  { key: 'type', title: 'Тип счетчика', render: (item) => typeCounter[item?.type] ?? item?.type },
  { key: 'num', title: 'Серийный номер' },
  {
    key: 'lastIndication.period',
    title: 'Период последнего показания',
    render: (item) => item?.lastIndication?.period,
  },
  { key: 'lastIndication.indication', title: 'Последние зарегистрированное показание', render: (item) => item?.lastIndication?.indication },
  {
    key: 'lastIndication.lastInputDate',
    title: 'Дата передачи последнего показания',
    render: (item) => {
      const lastInputDate = item?.lastIndication?.lastInputDate;
      if (lastInputDate) {
        const date = new Date(lastInputDate);
        return date.toLocaleDateString('ru-RU');
      }
      return null;
    },
  },
  { key: 'checkup', title: 'Дата следующей поверки счётчика' },
  {
    key: 'checkupStatus',
    title: 'Статус поверки',
    render: (item) => {
      const isExpired = item?.checkupStatus === 'EXPIRED';
      return <p className={isExpired ? 'text-red-500' : ''}>{isExpired ? 'Просрочен' : item?.checkupStatus}</p>;
    },
  },
];

const CountersData = ({ data }) => {
  return (
    <div className="flex flex-col gap-y-2">
      {data.map((counter, index) => (
        <div key={index} className="border p-2 rounded-2xl">
          {keys.map((col, idx) => {
            const value = col.render ? col.render(counter) : counter[col.key];
            if (!value) return null;

            return (
              <div key={idx} className="flex flex-col gap-x-2 py-1 sm:flex-row">
                <span className="font-medium">{col.title}:</span>
                <span className={'text-gray-700'}>{value}</span>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

const MosruGetInfoButton = (props) => {
  const { objectId } = props;
  const { data, getInfoFromMosru, modal, setModal, loading } = useMosruStore();

  const { street, house, flat, okrug, district } = data?.Address ?? {};
  const addressParts = [okrug, district, street ? `ул. ${street}` : null, house ? `д. ${house}` : null, flat ? `кв. ${flat}` : null];

  const address = addressParts.filter(Boolean).join(', ');

  const columns = [
    { title: 'Адрес', value: address },
    { title: 'Код плательщика', value: data?.paycode },
  ];

  return (
    <>
      <IntegrationButton Icon={InfoIcon} handleClick={() => getInfoFromMosru(objectId)} label={'Получить инфо'} />
      <Modal
        showModal={modal}
        setShowModal={setModal}
        title="Информация, полученная от Mos.ru"
        showSave={false}
        classWidth="relative w-11/12 lg:w-1/2 my-6 mx-2">
        {loading ? (
          <LoadingSpinner loading={true} />
        ) : !data ? (
          <div className={'text-center text-gray-700 p-2'}>Данные от mos.ru отсутствуют</div>
        ) : (
          <div className={'flex flex-col gap-y-2'}>
            {columns.map((colum, index) => {
              return colum.value ? (
                <div key={index} className="flex flex-col gap-y-1">
                  <span className={'font-bold'}>{colum.title}</span>
                  <div>{colum.value}</div>
                </div>
              ) : null;
            })}

            {data?.Counter && data?.Counter.length > 0 && (
              <div className="flex flex-col gap-y-2">
                <span className="font-bold">Счетчики</span>
                <CountersData data={data.Counter} />
              </div>
            )}
            {data?.inactiveCounter && data?.inactiveCounter.length > 0 && (
              <div className="flex flex-col gap-y-2">
                <span className="font-bold text-red-500">Неактивные счетчики</span>
                <CountersData data={data.inactiveCounter} />
              </div>
            )}
          </div>
        )}
      </Modal>
    </>
  );
};
export default MosruGetInfoButton;
